import axios from "axios";

import { logout } from "../reducers/auth.reducer";

let responseInterceptorId;

export function handleUnauthorizedResponse(error, store) {
  const isAuthenticationRequest = String(error.config?.url ?? "").includes(
    "/authenticate"
  );

  if (error.response?.status === 401 && !isAuthenticationRequest) {
    store.dispatch(logout());
    return true;
  }

  return false;
}

export function configureHttpClient(store) {
  if (responseInterceptorId !== undefined) {
    axios.interceptors.response.eject(responseInterceptorId);
  }

  responseInterceptorId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      handleUnauthorizedResponse(error, store);
      return Promise.reject(error);
    }
  );

  return responseInterceptorId;
}